import React from "react";

import { Route, Switch, useRouteMatch, Redirect } from "react-router-dom";

import FileUploadProvider from "../../components/FileUpload";
import useHasRole from "../../lib/hooks/useHasRole";

import ClientPage, { ClientCreatePage } from "./Client";
import ClientsRoute from "./Clients";

import Token from "./Client/Token/Token";

import TwilioClient from "./Client/Twilio/TwilioClient";
import SendGridClient from "./Client/SendGrid/Client";

import OutlookIntegration from "./Client/Outlook/Integration";
import ActiveDirectoryIntegration from "./Client/ActiveDirectory/Integration";

import EmailTemplate from "./Client/Email/EmailTemplate";
import MessageTemplate from "./Client/Message/MessageTemplate";
import EmailTemplates from "./Client/Email/EmailTemplates";
import ShellyController from "./Client/Shelly/ShellyController";
import ChatMessageTemplateEditor from "./Client/ChatMessages/TemplateEditor";

export const CurrentClientRoute = React.memo(() => {
  const { path } = useRouteMatch();
  const isAdmin = useHasRole(["ADMIN"]);

  return (
    <Switch>
      <Route exact path={`${path}/twilio-message-templates/new`}>
        <MessageTemplate />
      </Route>
      <Route exact path={`${path}/twilio-message-templates/:id`}>
        <MessageTemplate />
      </Route>
      <Route exact path={`${path}/sendgrid/:sendgridId/templates/new`}>
        <EmailTemplate />
      </Route>
      <Route exact path={`${path}/sendgrid/:sendgridId/templates/:id`}>
        <EmailTemplate />
      </Route>
      <Route exact path={`${path}/sendgrid/:sendgridId/templates`}>
        <EmailTemplates />
      </Route>
      <Route exact path={`${path}/sendgrid/new`}>
        <FileUploadProvider>
          <SendGridClient />
        </FileUploadProvider>
      </Route>
      <Route exact path={`${path}/sendgrid/:id`}>
        <FileUploadProvider>
          <SendGridClient />
        </FileUploadProvider>
      </Route>
      <Route exact path={`${path}/token/new`}>
        <Token />
      </Route>
      <Route exact path={`${path}/twilio/new`}>
        <TwilioClient />
      </Route>
      <Route path={`${path}/twilio/:id`}>
        <TwilioClient />
      </Route>
      <Route exact path={`${path}/integrations/outlook/:subscriptionId`}>
        <OutlookIntegration />
      </Route>
      <Route
        exact
        path={`${path}/integrations/activedirectory/:activeDirectoryId`}
      >
        <ActiveDirectoryIntegration />
      </Route>
      <Route exact path={`${path}/token/:id`}>
        <Token />
      </Route>
      <Route exact path={`${path}/shelly/new`}>
        <ShellyController />
      </Route>
      <Route exact path={`${path}/shelly/:id`}>
        <ShellyController />
      </Route>
      {/* ADMIN only; an ADMIN reaches their own client through /client too (sidebar). */}
      {isAdmin && (
        <Route exact path={`${path}/chat-messages/:template`}>
          <ChatMessageTemplateEditor />
        </Route>
      )}
      <Route path={path}>
        <ClientPage />
      </Route>
    </Switch>
  );
});

const ClientsRouter = React.memo(() => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <ClientsRoute />
      </Route>
      <Route exact path={`${path}/new`}>
        <ClientCreatePage />
      </Route>
      <Route exact path={`${path}/:clientId/twilio-message-templates/new`}>
        <MessageTemplate />
      </Route>
      <Route exact path={`${path}/:clientId/twilio-message-templates/:id`}>
        <MessageTemplate />
      </Route>
      <Route
        exact
        path={`${path}/:clientId/sendgrid/:sendgridId/templates/new`}
      >
        <EmailTemplate />
      </Route>
      <Route
        exact
        path={`${path}/:clientId/sendgrid/:sendgridId/templates/:id`}
      >
        <EmailTemplate />
      </Route>
      <Route exact path={`${path}/:clientId/sendgrid/:sendgridId/templates`}>
        <EmailTemplates />
      </Route>
      <Route exact path={`${path}/:clientId/sendgrid/new`}>
        <FileUploadProvider>
          <SendGridClient />
        </FileUploadProvider>
      </Route>
      <Route exact path={`${path}/:clientId/sendgrid/:id`}>
        <FileUploadProvider>
          <SendGridClient />
        </FileUploadProvider>
      </Route>
      <Route exact path={`${path}/:clientId/token/new`}>
        <Token />
      </Route>
      <Route exact path={`${path}/:clientId/twilio/new`}>
        <TwilioClient />
      </Route>
      <Route path={`${path}/:clientId/twilio/:id`}>
        <TwilioClient />
      </Route>
      <Route
        exact
        path={`${path}/:clientId/integrations/outlook/:subscriptionId`}
      >
        <OutlookIntegration />
      </Route>
      <Route
        exact
        path={`${path}/:clientId/integrations/activedirectory/:activeDirectoryId`}
      >
        <ActiveDirectoryIntegration />
      </Route>
      <Route exact path={`${path}/:clientId/token/:id`}>
        <Token />
      </Route>
      <Route exact path={`${path}/:clientId/shelly/new`}>
        <ShellyController />
      </Route>
      <Route exact path={`${path}/:clientId/shelly/:id`}>
        <ShellyController />
      </Route>
      <Route exact path={`${path}/:clientId/chat-messages/:template`}>
        <ChatMessageTemplateEditor />
      </Route>
      <Route path={`${path}/:clientId`}>
        <ClientPage />
      </Route>
      <Redirect to={path} />
    </Switch>
  );
});

export default ClientsRouter;
